import { render, staticRenderFns } from "./BarGraphBackground.vue?vue&type=template&id=1d43d53c&scoped=true&"
import script from "./BarGraphBackground.vue?vue&type=script&lang=ts&"
export * from "./BarGraphBackground.vue?vue&type=script&lang=ts&"
import style0 from "./BarGraphBackground.vue?vue&type=style&index=0&id=1d43d53c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1d43d53c",
  null
  
)

export default component.exports